(() => {
  const loginModule = document.querySelector('.login-module');
  if (!loginModule) return;

  const loginForm = document.querySelector('#loginModal .login-form');
  if (loginForm) {
    loginModule.querySelector('[data-slidein-option="returning-customer"] .slidein-options__option__inner').insertAdjacentElement('beforeend', loginForm);
  }

  // Slide-in option switching functionality
  const slideInOptions = loginModule.querySelectorAll('[data-slidein-option]');
  const navigationButtons = loginModule.querySelectorAll('.slidein-navigation button');
  const slideInBackButton = loginModule.querySelector('.slidein-back');

  // Function to switch between slide-in options
  function switchSlideInOption(targetOption) {
    // Remove active class from all options
    slideInOptions.forEach((option) => {
      option.classList.remove('active');
    });

    // Add active class to target option
    const targetElement = loginModule.querySelector(`[data-slidein-option="${targetOption}"]`);
    if (targetElement) {
      targetElement.classList.add('active');
    }

    // Update navigation button states
    navigationButtons.forEach((button) => {
      button.classList.remove('active');
    });

    // Add active class to corresponding navigation button
    const activeNavButton = loginModule.querySelector(`[data-slidein-target="${targetOption}"]`);
    if (activeNavButton) {
      activeNavButton.classList.add('active');
    }

    // Add/remove class based on returning customer active state
    if (targetOption === 'returning-customer') {
      loginModule.classList.remove('returning-customer-inactive');
    } else {
      loginModule.classList.add('returning-customer-inactive');
    }
  }

  // Set returning-customer as active by default when page loads
  switchSlideInOption('returning-customer');

  // Add click event listeners to navigation buttons
  navigationButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const targetOption = button.getAttribute('data-slidein-target');
      if (targetOption) {
        switchSlideInOption(targetOption);
      }
    });
  });

  // Add click event listener to slide-in back button
  if (slideInBackButton) {
    slideInBackButton.addEventListener('click', (e) => {
      e.preventDefault();
      switchSlideInOption('returning-customer');
    });
  }
})();
